module.exports = __webpack_public_path__ + "img/ssb_menu7.06c40a7d.png";